<template>
	<dms-edit-layout v-bind="layoutProps">
		<dms-row>
			<dms-col >
				<dms-card row header-localization-key="Zakladni_Informace">
					<dms-col :md="6" :sm="12" :xs="24">
					 <dms-input  :value.sync="SmVariaZkt" label-key="SM_VARIA_ZKT" />
					</dms-col>
					<dms-col :md="12" :sm="12" :xs="24">
					 <dms-input  :value.sync="Text" label-key="TEXT" />
					</dms-col>
				    <dms-col :md="6" :sm="12" :xs="24">
					 <dms-input  :value.sync="TextTisk2Dd" label-key="TEXT_TISK_2DD" />
				    </dms-col>
				</dms-card>
			</dms-col>
		</dms-row>
	</dms-edit-layout>
</template>

<script>
import { editFactory } from '@/main/pages';

import { store } from './store/edit';
import { NAME } from './constants';

export default editFactory(NAME, store);
</script>
